import { render, staticRenderFns } from "./ContactPersonForm.vue?vue&type=template&id=2d6b82d2&"
import script from "./ContactPersonForm.vue?vue&type=script&lang=js&"
export * from "./ContactPersonForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersonForm.vue?vue&type=style&index=0&id=2d6b82d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports